import React from "react";
import { motion } from "framer-motion";
import { industries } from "../Data";

const leftVariant = {
  hidden: {
    opacity: 0,
    x: -70,
    filter: "blur(12px)",
  },
  visible: {
    opacity: 1,
    x: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const grid = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.25,
    },
  },
};

const IndustriesSection = () => {
  return (
    <section className="industries-section">

      {/* Background Glow */}

      <motion.div
        className="industry-glow"
        animate={{
          scale: [1, 1.2, 1],
          opacity: [.4, .8, .4],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      <div className="container">

      <motion.div
          className="industries-left"
          variants={leftVariant}
        >

          <motion.h2
            className="section-heading"
            initial={{
              opacity: 0,
              y: 35,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              delay: 0.2,
              duration: 0.8,
            }}
            viewport={{ once: true }}
          >
            No matter your industry,
            <br />
            ONBBITS fits
          </motion.h2>

          <motion.p
            className="section-text"
            initial={{
              opacity: 0,
              y: 35,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              delay: 0.45,
              duration: 0.8,
            }}
            viewport={{ once: true }}
          >
            From startups to enterprises, ONBBITS adapts to every
            industry with powerful WhatsApp automation,
            helping you engage customers,
            streamline communication,
            and drive business growth.
          </motion.p>

        </motion.div>


        <div className="industries-right">

          <motion.div
            className="industries-grid"
            variants={grid}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: .15,
            }}
          >
            {industries.map((item, i) => (

          <div className="industries-card">
  <motion.img
    src={item.icon}
    alt={`${item.title} | Onbbits`}
    initial={{ opacity: 0, scale: 0 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true }}
    transition={{
      delay: i * 0.08,
      type: "spring",
      stiffness: 300,
    }}
  />

  <div className="industries-card-content">
    <motion.h3
      className="card-heading"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ delay: 0.15 + i * 0.08 }}
      viewport={{ once: true }}
    >
      {item.title}
    </motion.h3>

    <motion.p
      className="section-text"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ delay: 0.25 + i * 0.08 }}
      viewport={{ once: true }}
    >
      {item.desc}
    </motion.p>
  </div>
</div>

            ))}
          </motion.div>

        </div>

      </div>

    </section>
  );
};

export default IndustriesSection;